import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FeaturesComponent } from '../userEntityModals/features/features.component';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
// import { _ } from 'underscore';
import * as _ from 'underscore';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import {Messages} from '../constants/messages'
import { AddUnitComponent } from './add-unit/add-unit.component';
declare var google: any;
export interface NewEntity {
  name: string;
  address: string;
  location: any;
  features: string[];
  sub_features: string[];
}

@Component({
  selector: 'app-entity-details',
  templateUrl: './entity-details.component.html',
  styleUrls: ['./entity-details.component.scss']
})
export class EntityDetailsComponent implements OnInit {

  entityColumns: string[] = ['name', 'address', 'city', 'features', 'subFeatures', 'actions']; // , 'actions' - removed temporarily
  entityArray: any = [
    // { name: 'unit 1', address: 'indiranagar', city: 'bangalore', features: '', subFeatures: 'create order', actions: '' }
  ];
  showLoader = false;
  carrierUpdates: Subscription;
  helpData = [
    { head: 'Help', data: 'Add different Plants/Units/Warehouses/Branches here. ' },
    // { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];

  constructor(private dialog: MatDialog, private valid: ValidationService, private snackbar: SnackbarService, private http: HttpService,
              private events: EventService, private storage: StorageService, private route: Router) {
  const access_token = this.storage.getFromCookie('access_token');
  if (!access_token) {
    this.route.navigateByUrl('login');
  }
              }

  ngOnInit() {
    this.getEntities();
    this.carrierUpdates = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        console.log('data ', data);
        this.getEntities();
      }
    );
  }

  ngOnDestroy() {
    this.carrierUpdates.unsubscribe();
  }

  getEntities() {
    this.entityArray = [];
    this.showLoader = true;
    this.http.get('carrier/entity/all').subscribe(
      (data: any) => {
        this.showLoader = false;

        if (data.statusCode == 200) {
          const result = data.data;
          if (result && result.length) {
            result.forEach(element => {
              const temp: any = {
                features: [],
                subFeatures: []
              };
              temp._id = element._id;
              temp.name = element.name;
              temp.address = (element.location) ? element.location.area : '';
              temp.city = (element.location) ? element.location.city : '';
              temp.features = (element.features && element.features.length) ? element.features : [];
              temp.subFeatures = (element.sub_features && element.sub_features.length) ? element.sub_features : [];
              this.entityArray.push(temp);
            });
          }
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  openAddUnitModal() {
    const dialogRef =  this.dialog.open(AddUnitComponent, {
      data: {}
    });
    dialogRef.afterClosed().subscribe((data) => {
      if ( data && data.statusCode === 200) {
        this.events.carriersUpdated();
        this.getEntities();
      }
    });
  }
  editUnit(element) {
    const dataToSend: any = {
      data: element._id,
      edit: true
    };

    const dialogRef =  this.dialog.open(AddUnitComponent, {
      data: dataToSend
    });
    dialogRef.afterClosed().subscribe((data) => {
      if ( data && data.statusCode === 200) {
        this.getEntities();
      }
    });
   }

}
